import React, { useState, useEffect } from "react";
import { Edit, Edit2, Plus, Trash2 } from "lucide-react";
import { Button } from "../../components/Button";
import workflowApi from "../../api/workflowApi";
import { toast } from "react-toastify";
import FormField from "../../components/ui/FormField";
import { confirmSubmit } from "../../utils/confirmSubmit";

export const TemplateTasks = ({
  initialTasks = [],
  workflowId,
  token,
  onTasksUpdated,
  errors
}) => {
  const [tasks, setTasks] = useState([]);
  const today = new Date().toISOString().split("T")[0];

  console.log("tasks", tasks);
  

  useEffect(() => {
    setTasks(initialTasks);
  }, [initialTasks]);

  const updateTasks = (updated) => {
    setTasks(updated);
    onTasksUpdated?.(updated);
  };

  const handleTaskChange = (index, field, value) => {
    const updated = tasks.map((t, i) =>
      i === index ? { ...t, [field]: value } : t
    );
    updateTasks(updated);
  };

  const handleRemoveTask = async (index) => {
    const task = tasks[index];
    const isConfirmed = await confirmSubmit({
                      title: "Confirm task delete",
                      text: "Are you sure you want to delete this task?",
                      confirmText: "Submit",
                    });
                  if (!isConfirmed) return;
    try {
      if (task.id) {
        await workflowApi.removeTemplateTasks(workflowId, {}, token, task.id);
      }

      const updated = tasks.filter((_, i) => i !== index);
      updateTasks(updated);
      toast.success("Task removed successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to remove task");
    }
  };

  const handleAddTask = () => {
    updateTasks([
      ...tasks,
      {
        title: "",
        description: "",
        priority: "MEDIUM",
        status: "TODO",
        startDate: "",
        dueDate: "",
        editable: true,
      },
    ]);
  };

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-gray-800">
        Tasks ({tasks.length})
      </h4>

      {tasks.map((task, index) => (
        <div
          key={task.id || `new-${index}`}
          className="p-2 border rounded-md bg-gray-50 relative"
        >
            <div className="absolute top-2 right-2 flex gap-2">
              <button
                type="button"
                onClick={() => handleRemoveTask(index)}
                className="text-red-600 hover:text-red-800"
                title="Delete Task"
              >
                <Trash2 size={16} />
              </button>
            </div>

          {/* Title + Priority */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <FormField
                label="Task Title"
                value={task.title}
                onChange={(e) =>
                    handleTaskChange(index, "title", e)
                }
                placeholder="Enter Template Name"
                error={errors?.tasks?.[index]?.title}
                required
            />
            <FormField
                label="Priority"
                type="dropdown"
                value={task?.priority}
                options={['LOW', 'MEDIUM', 'HIGH']}
                onChange={(e) =>
                    handleTaskChange(index, "priority", e)
                }
                error={errors?.tasks?.[index]?.priority}
                required
            />
          </div>

          {/* Dates */}
          <div className="grid grid-cols-2 gap-2 mt-1">
            <FormField
              label="Start Date"
              type="date"
              required
              min={new Date().toISOString().split("T")[0]}
              value={task.startDate}
              onChange={(e) =>
                handleTaskChange(index, "startDate", e)
              }
              error={errors?.tasks?.[index]?.startDate}
            />

            <FormField
              label="Due Date"
              type="date"
              required
              min={task.startDate}
              value={task.dueDate}
              onChange={(e) =>
                handleTaskChange(index, "dueDate", e)
              }
              error={errors?.tasks?.[index]?.dueDate}
            />
          </div>
          {/* Description */}
          <div className="mt-1">
          <FormField
              label="Description"
              type="description"
              rows="2"
              required
              value={task.description}
              onChange={(e) =>
                handleTaskChange(index, "description", e)
              }
              error={errors?.tasks?.[index]?.description}
            />
          </div>

        </div>
      ))}

        <div className="flex justify-end">
          <Button label={<Plus />} onClick={handleAddTask} />
        </div>
    </div>
  );
};

